import React from 'react';
import Class10Elucidation2024 from '../views/Class10Elucidation2024';
const ClassAssemblyPage = () => {
    return <Class10Elucidation2024/>;
  };
  export default ClassAssemblyPage;